import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconDragHandleHorizontal$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconDragHandleHorizontal extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '34ed02eba4f1863bf9240b4022d502f1d94cbec3', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '7c7d99fcef355b40f4d354359a0f666abe4016ba', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'b4be30e5d827c41ed8e8c18d50968ff99037eb13', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11 9.507a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667m0 5.666a1.333 1.333 0 1 0 0-2.666 1.333 1.333 0 0 0 0 2.666M6.667 13.84a1.333 1.333 0 1 1-2.667 0 1.333 1.333 0 0 1 2.667 0M5.333 9.507a1.333 1.333 0 1 0 0-2.667 1.333 1.333 0 0 0 0 2.667M18 8.173a1.333 1.333 0 1 1-2.667 0 1.333 1.333 0 0 1 2.667 0m-1.333 7a1.333 1.333 0 1 0 0-2.666 1.333 1.333 0 0 0 0 2.666", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-drag-handle-horizontal", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-drag-handle-horizontal"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-drag-handle-horizontal":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconDragHandleHorizontal$1);
            }
            break;
    } });
}

const CosmosIconDragHandleHorizontal = CosmosIconDragHandleHorizontal$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconDragHandleHorizontal, defineCustomElement };
